import type { IconComponent } from '../../components/Button';
import type { Segment } from '../../components/SegmentedControl/SegmentedControl.types';

/** One segment of the deck's side-pane tab row (Flashcards · Exam & Quizzes · …). */
export interface DeckSidePaneSegment<V extends string = string> {
  value: V;
  /** Pre-translated name ("Flashcards", "Exam & Quizzes"). */
  label: string;
  /**
   * Live item count, shown in the label as `Label: N` — web's format, and the
   * one the quiz filter chips use. Omit for a plain name (a pane too narrow to
   * carry the count).
   */
  count?: number;
  icon?: IconComponent;
  testID?: string;
}

/** `Flashcards: 10` — ONE format for every client that labels a pane with its count. */
export function deckSidePaneSegmentLabel(label: string, count?: number): string {
  return count == null ? label : `${label}: ${count}`;
}

/** The segmented control's items for {@link DeckSidePaneSegment}s, in order. */
export function deckSidePaneSegmentItems<V extends string>(
  segments: readonly DeckSidePaneSegment<V>[],
): Segment<V>[] {
  return segments.map((segment) => ({
    value: segment.value,
    label: deckSidePaneSegmentLabel(segment.label, segment.count),
    icon: segment.icon,
    testID: segment.testID,
  }));
}
